<template>
  <PortalWidget
    :widget="widgetTitle"
  >
    <v-table
      :data="billingMonths"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            v-t="'REFERENCE_PERIOD'"
            sort-key="readableDt"
          />

          <v-th
            v-t="'INVOICE'"
            sort-key="readableDt"
          />
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.readableDt"
        >
          <td> {{ formatDate(row.readableDt) }}  </td>
          <td>
            <a
              class="btn btn-list-function" 
              @click="exportInvoice(row)"
            >
              <i
                v-tooltip.right.hover="{ text:$t('DOWNLOAD_INVOICE_MONTH'), transition: 0 }"
                class="fa fa-download"
                aria-hidden="true"
              />
            </a>
          </td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :max-page-links="10"
        />
      </div>
    </div>

    <div
      v-if="tableEmpty"
      v-t="'BILLING_MONTHS_TABLE_EMPTY'"
      class="well well-sm text-center"
    />
  </PortalWidget>
</template>

<script>

import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapActions, mapState, mapGetters } from 'vuex';
import { EXPORT_MONTH_BILLING_INVOICE, LOAD_BILLING_MONTHS } from '../../store/actionTypes';


export default {
  data() {
    return {
      widgetTitle: { title:this.$i18n.t('MONHTLY_BILLING'), iconClass: 'typcn typcn-book'},
      currentPage: 1,
      totalPages: 0,
    };
  },

  computed: {
    ...mapState('billingSettingsStore', ['billingMonths']),
    ...mapState('billingSettingsStore', {
      tableEmpty: (state) => state['BillingMonths'] && state['BillingMonths'].length === 0
    }),
  },

  created() {
      this.loadBillingMonths()
  },

  methods: {
    ...mapActions('billingSettingsStore',  [
      EXPORT_MONTH_BILLING_INVOICE,
      LOAD_BILLING_MONTHS
    ]),

    formatDate(dateStr) {
      return dateStr.replace(',', '');
    },

    exportInvoice(billableMonth) {
      this.exportMonthBillingInvoice(billableMonth);
    }
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style>

</style>